import { createContext, useContext, useState, useMemo } from 'react';

// Which agent the current dashboard user is looking at. A customer org may
// have multiple verso-agent instances (multiple PBX sites); this context
// tracks which one is currently selected in the Header dropdown.

const AgentContext = createContext(null);

export function AgentProvider({ children }) {
  const [agentId, setAgentId] = useState(null);

  const value = useMemo(() => ({ agentId, setAgentId }), [agentId]);

  return (
    <AgentContext.Provider value={value}>
      {children}
    </AgentContext.Provider>
  );
}

export function useAgentStore() {
  const context = useContext(AgentContext);
  if (!context) {
    throw new Error('useAgentStore must be used within an AgentProvider');
  }
  return context;
}
